<template>
  <div>
    <div class="hint-box">
      <div>注意：</div>
      <p v-if="info.fullScope"> 1.当前账号（ADMIN / 大区数据管理员）可导出平台全部研修班、体验班客户，包含客户身份，保留省、市、区，不包含电话号码和详细地址。导出增加订货数、余额/现金支付总价、零售价支付总价、赠送支付总价、秒杀数、秒杀支付总价。<br />
        付款时间包含开始、结束日期当天；不选则统计全部有效订单。仅统计待发货、已发货、已完成的已付款订单；无符合条件订单的客户统计为0。余额、零售价、学费为当前账户金额。<br />
        2.为了数据完整，下载的文件只保留3天的有效期，过了就自动删除记录和文件。请早些下载！<br />
        3.导出表格如果等待时间太长，可以关闭标签页，或关闭浏览器，下载完成后即可直接下载文件</p>
      <p v-else> 1.{{ info.marketingScope ? '可导出当前营销经理管辖范围内的全部客户，并按客户身份筛选' : '仅可导出本大区管辖的研修班、体验班客户' }}，包含客户身份，保留省、市、区，不包含电话号码和详细地址。导出增加订货数、余额/现金支付总价、零售价支付总价、赠送支付总价、秒杀数、秒杀支付总价。<br />
        付款时间包含开始、结束日期当天；不选则统计全部有效订单。仅统计待发货、已发货、已完成的已付款订单；无符合条件订单的客户统计为0。余额、零售价、学费为当前账户金额。<br />
        2.为了数据完整，下载的文件只保留3天的有效期，过了就自动删除记录和文件。请早些下载！<br />
        3.导出表格如果等待时间太长，可以关闭标签页，或关闭浏览器，下载完成后即可直接下载文件</p>
    </div>
    <div class="filter-container">
      <el-form :model="query" ref="queryForm" :inline="true">
        <el-form-item :label="info.marketingScope ? '当前营销经理：' : '当前大区：'">
          <span class="area-name">{{ info.areaName || '-' }}</span>
          <span class="area-pho" v-if="info.areaPho">（{{ info.areaPho }}）</span>
        </el-form-item>
        <el-form-item label="客户身份：">
          <el-select v-model="query.cLevel" placeholder="全部" clearable size="small">
            <el-option label="全部" :value="undefined" />
            <el-option :label="item.name" :value="item.id" v-for="item in info.levels" :key="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="付款时间：">
          <el-date-picker
            v-model="paymentRange"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            clearable
            size="small"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleDownload" size="mini" :disabled="!info.areaId && !info.fullScope && !info.marketingScope">导出</el-button>
        </el-form-item>
      </el-form>
    </div>
    <task-list v-if="info.areaId || info.fullScope || info.marketingScope" :key="taskCode" ref="taskList" :task-code="taskCode" />
  </div>
</template>

<script>
import areaExportApi from '@/api/count/areaExport'
import TaskList from './TaskList'

// 大区客户导出任务编码，与后端 CustomerService_TEE.AREA_EXPORT_TASK_CODE 保持一致
const TASK_CODE = 'EEForAreaCustomer'

export default {
  components: {
    TaskList
  },
  data() {
    return {
      TASK_CODE,
      info: {},
      paymentRange: [],
      query: {
        cLevel: undefined
      }
    }
  },
  created() {
    this.getInfo()
  },
  computed: {
    taskCode() {
      return this.info.exportTaskCode || TASK_CODE
    }
  },
  methods: {
    /**
     * 获取当前登录账号绑定的大区
     */
    getInfo() {
      return areaExportApi.fetchInfo().then(({ data }) => {
        this.info = data || {}
      })
    },
    handleDownload() {
      const range = this.paymentRange || []
      const params = {
        cLevel: this.query.cLevel,
        paymentDateStart: range[0],
        paymentDateEnd: range[1]
      }
      return this.$common.confirm('是否确认导出')
        .then(() => areaExportApi.exportExcel(params))
        .then((res) => {
          if (res.code === '0') {
            setTimeout(() => {
              this.$refs.taskList.doQueryList({ pageNo: 1 })
            }, 1000)
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
@import './export-common.scss';
</style>
